import { render, staticRenderFns } from "./EditorFontStyle.vue?vue&type=template&id=f90c6608&scoped=true&"
import script from "./EditorFontStyle.vue?vue&type=script&lang=js&"
export * from "./EditorFontStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c6608",
  null
  
)

export default component.exports